import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
// 恢复为默认线上 API 地址（如果需要在组件内使用本地 mock，请在组件中读取 `/mock/*.json`）
axios.defaults.baseURL = '' 

// 在 mock-only 模式下拦截所有请求并阻止发送到后端，统一返回拒绝，防止页面发起外网请求
// 移除 mock-only 拦截器

// 全局定义axios
Vue.prototype.$http = axios

// 图片服务器地址
// Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'
Vue.prototype.imgserver = 'http://localhost:8080/'
// Vue.prototype.imgserver = '/'



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')